<template>
  <div class="setting_area">
    <div class="subtitle">
      <p class="name">动检区域检查</p>
      <div class="close" @click="closeArea">
        <img class="icon" src="@/assets/img/close_black.png">
      </div>
    </div>
    <div class="function_area">
      <div class="area_video">
        <myvideo v-if="video_url" ref="videoa1" :isFix="true" :source="video_url" width="800" height="450"
          cbData="a1"></myvideo>
      </div>
      <div class="area_block">
        <template v-for="(itemY, yIndex) in regionInfo">
          <div :class="(itemX == '1' && !isKnow) ? 'on' : ''" style="font-size:12px;color:red"
            v-for="(itemX, xIndex) in itemY" class="block"
            :style="'width:' + blockWidth + 'px;height:' + blockHeight + 'px'" @click="selectBlock(xIndex, yIndex)">
          </div>
        </template>
        <div class="clear"></div>
      </div>
      <div class="area_write" @mousedown.prevent="onMouseDown($event)" @mouseup.prevent="onMouseUp($event)"
        @mousemove.prevent="onMouseMove($event)">
        <div id="div" :style="style"></div>
      </div>
    </div>
    <div class="function_area_btn">
      <div @click="invertBlock()" class="btn btn-secondary">画面反向</div>
      <div @click="saveBlock()" class="btn btn-primary">保存</div>
    </div>
    <div class="function_area_tip" v-if="isKnow">
      <div class="tip_top tap_background">
        <p>点击、框选网格进行动检区域设置，非区域内画面变化将不产生动检报警</p>
      </div>
      <div class="tip_middle">
        <div class="left_right tap_background">
        </div>
        <div class="func_shaow">
        </div>
        <div class="left_middle tap_background">
        </div>
        <div class="func_shaow tap_select_background">
        </div>
        <div class="left_right tap_background">
        </div>
        <div class="clear"></div>
      </div>
      <div class="tip_bottom tap_background">
        <div class="tip_text">
          <div class="left_text">
            非动检区域
          </div>
          <div class="right_text">
            动检区域
          </div>
        </div>
        <div class="agree_bth" @click="toKnowAgree">
          知道了
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import myvideo from './../myvideo/myvideo.vue';
import axios from 'axios';
const ratioX = 30;
const ratioY = 25;
var isClick = 0, x1 = 0, y1 = 0, x2 = 0, y2 = 0;
export default {
  components: {
    myvideo
  },
  name: 'SettingAreaCmp',
  data() {
    return {
      style: '',
      isKnow: true,
      loading: false,
      video_url: '',
      blockWidth: 0,
      blockHeight: 0,
      regionInfo: []
    }
  },
  watch: {
    rowData(newValue, oldValue) {
      this.getBlockSize();
    },
    columnData(newValue, oldValue) {
      this.getBlockSize();
    },
    regionData(newValue, oldValue) {
      this.getBlockInfo(newValue);
    },
  },
  props: {
    rowData: {
      type: Number,
      default: 0
    },
    columnData: {
      type: Number,
      default: 0
    },
    regionData: {
      type: Array,
      default: []
    },
    videoInfo: {
      type: [Object, Array],
      default: function () {
        return [];
      }
    }
  },
  mounted() {
    let _this = this;
    _this.getBlockInfo(_this.regionData);
    _this.getBlockSize();
    setTimeout(function () {
      _this.video_url = _this.videoInfo.url;
    }, 100);
  },
  methods: {
    getBlockInfo(regionData) {
      let regionInfo = []
      for (let i = 0; i < regionData.length; i++) {
        regionInfo[i] = regionData[i].split('');
      }
      this.regionInfo = regionInfo;
    },
    getBlockSize() {
      let rowData = this.rowData;
      if (rowData > 0) {
        this.blockHeight = 450 / parseInt(rowData);
      }
      let columnData = this.columnData;
      if (columnData > 0) {
        this.blockWidth = 800 / parseInt(columnData);
      }
    },
    reCalc() {
      var x3 = Math.min(x1, x2);
      var x4 = Math.max(x1, x2);
      var y3 = Math.min(y1, y2);
      var y4 = Math.max(y1, y2);
      this.style = 'left:' + x3 + 'px;' + 'top:' + y3 + 'px;' + 'width:' + (x4 - x3) + 'px;' + 'height:' + (y4 - y3) + 'px;'
    },
    onMouseDown(e) {
      if (!this.isKnow) {
        x1 = e.offsetX;
        y1 = e.offsetY;
        x2 = e.offsetX;
        y2 = e.offsetY;
        isClick = 1;
      }
    },
    onMouseUp(e) {
      if (!this.isKnow) {
        isClick = 0;
        this.selectBlock();
      }
    },
    onMouseMove(e) {
      if (isClick == 1 && !this.isKnow) {
        x2 = e.offsetX;
        y2 = e.offsetY;
        this.reCalc();
      }
    },
    selectBlock() {
      let rowData = this.blockHeight;
      let columnData = this.blockWidth;
      var x3 = Math.min(x1, x2);
      var x4 = Math.max(x1, x2);
      var y3 = Math.min(y1, y2);
      var y4 = Math.max(y1, y2);
      let formX = Math.floor(x3 / columnData);
      let formY = Math.floor(y3 / rowData);
      let toX = Math.floor(x4 / columnData);
      let toY = Math.floor(y4 / rowData);
      let regionInfo = JSON.parse(JSON.stringify(this.regionInfo));
      let value = regionInfo[formY][formX] == '1' ? '0' : '1';
      for (let i = 0; i < regionInfo.length; i++) {
        for (let j = 0; j < regionInfo[i].length; j++) {
          if (i >= formY && i <= toY && j >= formX && j <= toX) {
            regionInfo[i][j] = value;
          }
        }
      }
      this.regionInfo = regionInfo;
      this.style = "";
      x1 = 0; x2 = 0; y1 = 0; y2 = 0;
    },
    closeArea() {
      this.$emit('onClose', { data: 0 });
    },
    toKnowAgree() {
      this.isKnow = false;
    },
    invertBlock() {
      let regionInfo = JSON.parse(JSON.stringify(this.regionInfo));
      for (let i = 0; i < regionInfo.length; i++) {
        for (let j = 0; j < regionInfo[i].length; j++) {
          if (regionInfo[i][j] == '0') {
            regionInfo[i][j] = '1';
          } else {
            regionInfo[i][j] = '0';
          }
        }
      }
      this.regionInfo = regionInfo;
    },
    saveBlock() {
      let _this = this;
      this.$swal({
        title: '确定保存',
        text: "保存后检测区域将被更改！",
        icon: 'warning',
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        customClass: {
          confirmButton: 'sweet-btn-primary',
        },
        width: 200,
        confirmButtonColor: '#3b82f6',
      }).then(async result => {
        if (result.isConfirmed) {
          _this.saveRegion();
        }
      })
    },
    saveRegion() {
      let data = [];
      let regionInfo = JSON.parse(JSON.stringify(this.regionInfo));
      for (let i = 0; i < regionInfo.length; i++) {
        for (let j = 0; j < regionInfo[i].length; j++) {
          let res = regionInfo[i].join('');
          data[i] = res;
        }
      }
      data = data.join(',');
      let _this = this;
      if (_this.loading) return;
      _this.loading = true;
      axios.post(_this.$store.state.base_url + 'Monitor_Center/setDeviceAlarmParam', {
        channel_id: 0,
        device_code: _this.videoInfo.device_code,
        region: data
      }).then(function (response) {
        _this.loading = false;
        if (response.status === 200 && response.data.code == 1) {
          _this.$swal('保存成功')
          _this.swalToast('保存成功', 'success');
          setTimeout(function () {
            _this.$emit('onClose', {
              data: 1
            })
          }, 2000);
        } else {
          _this.swalToast(response.data.info);
        }
      }).catch(function (error) {
        _this.loading = false;
        _this.swalToast(error);
      }).finally(function () { });
    },
    swalToast(message, icon = 'warning') {
      this.$swal({
        position: 'center',
        icon: icon,
        title: message,
        showConfirmButton: false,
        timer: 3000
      });
    }
  }
}
</script>

<style scoped>
.setting_area {
  width: 900px;
  height: 620px;
  position: fixed;
  z-index: 99;
  top: 50%;
  margin-top: -310px;
  left: 50%;
  margin-left: -450px;
  background: #0f172a;
  border: 1px solid #1e293b;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
}

.setting_area .subtitle {
  height: 48px;
  background: #1e293b;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  border-bottom: 1px solid #334155;
}

.setting_area .subtitle .name {
  font-size: 16px;
  font-weight: 500;
  color: #e2e8f0;
}

.setting_area .subtitle .close {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.3s;
}

.setting_area .subtitle .close:hover {
  background: #334155;
}

.setting_area .subtitle .close .icon {
  width: 16px;
  height: 16px;
  opacity: 0.7;
}

.setting_area .function_area {
  margin: 24px auto 0;
  width: 800px;
  height: 450px;
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #334155;
}

.area_video {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 1;
}

.setting_area .function_area .area_block {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 5;
  border-top: 1px solid #3b82f6;
  border-left: 1px solid #3b82f6;
  box-sizing: content-box;
}

.setting_area .function_area .area_block .block {
  width: 40px;
  height: 30px;
  background-color: rgba(32, 26, 19, .2);
  border-bottom: 1px solid #3b82f6;
  border-right: 1px solid #3b82f6;
  float: left;
}

.setting_area .function_area .area_block .block.on {
  background-color: rgba(59, 130, 246, .5);
}

.setting_area .function_area .area_write {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 11;
}

.setting_area .function_area .area_write #div {
  position: absolute;
  background-color: rgba(59, 130, 246, .5);
  border: 1px solid #3b82f6;
}

.function_area_btn {
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-top: 20px;
}

.function_area_btn .btn {
  padding: 8px 32px;
  font-size: 13px;
  font-weight: 500;
  text-align: center;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s;
}

.function_area_btn .btn-primary {
  background: #3b82f6;
  color: white;
  border: 1px solid #3b82f6;
}

.function_area_btn .btn-primary:hover {
  background: #2563eb;
}

.function_area_btn .btn-secondary {
  background: transparent;
  color: #94a3b8;
  border: 1px solid #334155;
}

.function_area_btn .btn-secondary:hover {
  background: #1e293b;
  border-color: #475569;
}

.function_area_tip {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 201;
  top: 0;
  left: 0;
}

.function_area_tip .tip_top {
  width: 100%;
  height: 302.5px;
  font-size: 15px;
  line-height: 30%;
  color: white;
  text-align: center;
  padding-top: 200px;
}

.function_area_tip .tip_top p {
  line-height: 50px;
  font-size: 12px;
}

.function_area_tip .tip_middle {
  width: 100%;
}

.function_area_tip .tip_middle .left_right {
  width: 232.5px;
  height: 75px;
  float: left;
}

.function_area_tip .tip_middle .left_middle {
  width: 285px;
  height: 75px;
  float: left;
}

.function_area_tip .tip_middle .func_shaow {
  width: 75px;
  height: 75px;
  float: left;
}

.function_area_tip .tip_bottom {
  width: 100%;
  height: calc(100% - 377.5px);
}

.function_area_tip .tip_bottom .tip_text {
  width: 100%
}

.function_area_tip .tip_bottom .tip_text .left_text {
  margin-left: 220px;
  width: 100px;
  line-height: 40px;
  float: left;
  text-align: center;
  font-size: 12px;
  color: white;
}

.function_area_tip .tip_bottom .tip_text .right_text {
  margin-right: 220px;
  width: 100px;
  line-height: 40px;
  float: right;
  text-align: center;
  font-size: 12px;
  color: white;
}

.function_area_tip .tip_bottom .agree_bth {
  margin: 20px auto 0;
  width: 100px;
  line-height: 35px;
  background: #3b82f6;
  color: white;
  font-size: 14px;
  text-align: center;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.3s;
}

.function_area_tip .tip_bottom .agree_bth:hover {
  background: #2563eb;
}

.tap_background {
  background-color: rgba(32, 26, 19, .6);
}

.tap_select_background {
  background-color: rgba(59, 130, 246, .5);
}
</style>
